import React from "react";

import Layout from "../components/layout";
import ruey from "../images/ruey.jpg";
import pai from "../images/pai.jpg";
import jenny from "../images/jenny.jpg";
import fiona from "../images/fiona.jpg";

const AboutUsPage = () => {
  return (
    <Layout>
      <div className="about-us">
        <section className="section-photo"></section>
        <section className="section-content">
          <div className="u-center-text u-margin-bottom-big">
            <h2 className="heading-secondary">Our Story</h2>
          </div>
          <div className="row">
            <p className="paragraph">
              NeoVative was founded in 2014 by Dr. Ruey-Kang Chang, a pediatric
              cardiologist and Professor at UCLA. Over 20 years of working in
              one of the busiest public hospitals in Los Angeles, Dr. Chang had
              been in many code blues in the ward, ICU, and ER. He noticed that
              the way code blue CPR is documented is a very old way of using a
              “code sheet” paper recorded by a senior nurse in the code blue
              team. This old way of documenting has many problems—
            </p>
            <p className="paragraph">
              Dr. Chang decided to bring the code blue events to the 21st
              century medical practice. BlueBox is a wearable digital code blue
              event recorder.
            </p>
          </div>
          <div className="u-center-text u-margin-bottom-big">
            <h2 className="heading-secondary">Team</h2>
          </div>
          <div className="row">
            <div className="col-1-of-2">
              <div className="section-team">
                <figure className="section-team__shape">
                  <img src={ruey} alt="" className="section-team__img" />
                </figure>
                <div className="section-team__text-box">
                  <h3 className="section-team__text">CEO</h3>
                  <p>Ruey-Kang Chang</p>
                </div>
              </div>
            </div>
            <div className="col-1-of-2">
              <div className="section-team">
                <figure className="section-team__shape">
                  <img src={pai} alt="" className="section-team__img" />
                </figure>
                <div className="section-team__text-box">
                  <h3 className="section-team__text">CTO</h3>
                  <p>Pai Chou</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-1-of-2">
              <div className="section-team">
                <figure className="section-team__shape">
                  <img src="" alt="" className="section-team__img" />
                </figure>
                <div className="section-team__text-box">
                  <h3 className="section-team__text">CFO</h3>
                  <p>Peter Chang</p>
                </div>
              </div>
            </div>
            <div className="col-1-of-2">
              <div className="section-team">
                <figure className="section-team__shape">
                  <img src={jenny} alt="" className="section-team__img" />
                </figure>
                <div className="section-team__text-box">
                  <h3 className="section-team__text">Chief Product Manager</h3>
                  <h3 className="section-team__text">System Engineer</h3>
                  <p>Jenny Huang</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-1-of-2">
              <div className="section-team">
                <figure className="section-team__shape">
                  <img src="" alt="" className="section-team__img" />
                </figure>
                <div className="section-team__text-box">
                  <h3 className="section-team__text">Chief Software Engineer</h3>
                  <p>Jonathan Wu</p>
                </div>
              </div>
            </div>
            <div className="col-1-of-2">
              <div className="section-team">
                <figure className="section-team__shape">
                  <img src={fiona} alt="" className="section-team__img" />
                </figure>
                <div className="section-team__text-box">
                  <h3 className="section-team__text">Office/Accounting Manager</h3>
                  <p>Fiona Li</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default AboutUsPage;
